module.exports = __webpack_public_path__ + "media/images/what_to_expect-8dfd55a2ef077288ca739306b3e63d81.jpg";